export default __webpack_public_path__ + "static/media/add-person.b4d3cb54.png";